import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'
import { Modal } from 'components/modal/Modal'
import { MoreInformationPopupProps as Props } from './types'

export const MoreInformationPopup: FC<Props> = ({ isOpen, onRequestClose, i18nKey }) => {
  // i18n
  const { t } = useTranslation('simulation')
  const description = t(i18nKey)

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title=""
      style={{
        maxWidth: '600px',
        maxHeight: '300px'
      }}
    >
      <div>{parse(description)}</div>
    </Modal>
  )
}
